import React from "react";
const FormInput = ({
    name,
    placeholder,
    value,
    onChange,
    onBlur,
    disabled,
    label,
    icon,
    type,
    isInvalid,
    invalidMessage
}) => {
    return (
        <>
            <div className="form-floating position-relative">
                <input
                    type={type}
                    placeholder={placeholder}
                    name={name}
                    value={value}
                    onChange={onChange}
                    disabled={disabled}
                    onBlur={onBlur}
                    className={`form-control ${icon && "form-control-icon"}`}
                />

                {icon && (
                    <span className="position-absolute translate-middle-y top-50 start-10 p-1rem">
                        <div className="d-flex justify-content-center">
                            {icon}
                        </div>
                    </span>
                )}

                <label htmlFor="floatingInput" className={`${icon && 'label-icon'}`}>
                    {label}
                </label>
                {isInvalid && (
                    <p className="text-danger">
                        {invalidMessage}
                    </p>
                )}
            </div>
        </>
    );
};

export default FormInput;
